import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import { v4 as uuidv4 } from "uuid";

// Custom Component
import Legend from "../../Legend/Legend";
import FileDropzone from "../../FileDropzone/WorkflowFileDropzone";
import TransmittalFileZoneContent from "./TransmittalFileZoneContent";
import ConfirmDialog from "../../Dialog/ConfirmDialog";
import SaveWarnDialog from "../../Dialog/SaveWarnDialog";
import FullScreenDialog from "../../Dialog/FullScreenDialog";
import { Alert } from "../../Alert/Alert";
import WebViewer from "../../WebViewer/WebViewer";

// Material-UI Core
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import { webViewerSaveAnnotation } from "../../../global/webViewerSaveAnnotation";

import Efiling from "../../../views/Efiling/Efiling.js";
import { getFile } from "../../../global/getPropertyInfo";

// Material-UI Element
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

// Fetch Data
import {
  getPropertyDetail,
  getCompanyList,
  removePropertyFile,
  setPrimary,
  fileUpload,
  fileDownload,
  addFileProperty,
} from "../../../dataSource/fileManager";
import { sub } from "date-fns";

// Custom Style
import { transAtthStyle } from "../../../styles/jss/components/transmittal/transAtthStyle";

const useStyles = makeStyles((theme) => transAtthStyle(theme));
const store = require("store");
const TransmittalSoftCopy = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const userModulesRedux = useSelector((state) => state.userModulesRedux);
  const [fileUploadingProperty, setFileUploadingProperty] = useState([]);
  const [filePreviewProperty, SetFilePreviewProperty] = useState(null);
  const [filePreviewDialogOpen, setFilePreviewDialogOpen] = useState(false);
  const [saveWarnDialogOpen, setSaveWarnDialogOpen] = useState(false);
  const [saveWarnDialogData, setSaveWarnDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    saveAction: "",
    dontSaveAction: "",
    cancelAction: "",
  });
  const [fileManagerDialogOpen, setFileManagerDialogOpen] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogData, setConfirmDialogData] = useState({
    dialogTitle: "",
    dialogContent: "",
    confirmAction: "",
    cancelAction: "",
  });
  const [presetFiles, setPresetFiles] = useState(null);
  const [presetSubject, setPresetSubject] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertData, setAlertData] = useState({
    type: "",
    title: "",
    content: "",
  });
  const propertySeqRedux = useSelector((state) => state.propertySeqRedux);
  const { softCopyTemplate, setSoftCopyTemplate } = props;
  const [removeRFIAtt, setRemoveRFIAtt] = useState({ removeRFIArr: [] });
  const {
    submissionValue,
    setSubmissionValue,
    setSelectSoftCopyDialogOpen,
    // buildAlert,
    isNew,
  } = props;

  const saveSoftCopy = () => {
    let data = { ...submissionValue };
    data.documents = Object.assign([], data.documents);
    softCopyTemplate.id = submissionValue.documents.length;
    data.documents.push(softCopyTemplate);
    setSubmissionValue({ ...submissionValue, ...data });
    setSelectSoftCopyDialogOpen(false);
    dispatch({
      type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
      data: { ...submissionValue, ...data },
    });
  };

  // Build Alert
  const buildAlert = (data) => {
    setAlertData({
      type: data.type,
      title: data.title,
      content: data.content,
    });
    setAlertOpen(true);
  };

  // Build Confirm Dialog
  const confirmDialogHandleOpen = (data) => {
    setConfirmDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      confirmAction: data.confirmAction,
      cancelAction: data.cancelAction,
    });

    setConfirmDialogOpen(true);
  };

  // Main Action
  const fileUploadAction = (fileType, acceptedFilesPool) => {
    let UploadingSource = buildFileUploadingProperty(acceptedFilesPool);
    acceptedFilesPool.map((file) => {
      fileUpload(file).then((res) => {
        console.log(
          "*****************************************************************************"
        );
        console.log("Temporary upload File Successful");
        console.log(res);
        console.log(
          "*****************************************************************************"
        );
        UploadingSource = removeFileUploadingProperty(UploadingSource, file);
        // buildFileRecordFromHarddisk(fileType, res.data[0])
        buildFileRecord(fileType, res.data[0]);
      });
    });
  };

  const buildFileUploadingProperty = (fileUploadRecord) => {
    const res = [...fileUploadingProperty, ...fileUploadRecord];

    setFileUploadingProperty(res);
    dispatch({
      type: "ADD_FILE_UPLOADING_PROPERTY",
      data: res,
    });

    return res;
  };

  const removeFileUploadingProperty = (sourceRecords, key) => {
    if (sourceRecords) {
      const res = sourceRecords.filter((sourceRecord) => sourceRecord !== key);

      setFileUploadingProperty(res);
      dispatch({
        type: "ADD_FILE_UPLOADING_PROPERTY",
        data: res,
      });

      return res;
    }
  };
  const buildFileRecord = (fileType, fileUploadRecord) => {
    const val = { ...softCopyTemplate };
    fileUploadRecord.modifydate = "";
    val.messages.files.push(fileUploadRecord);

    setSoftCopyTemplate({ ...softCopyTemplate, ...val });
    dispatch({
      type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
      data: { ...softCopyTemplate, val },
    });
    for (const atth of val.messages.files) {
      let data = { ...submissionValue };
      if (
        data.documents.map((obj) => obj.file_seq).indexOf(atth.file_seq) === -1
      ) {
        let fileObject = {
          id: uuidv4(),
          material: atth.filename,
          type: "softcopy",
          ref_no: "",
          atthDate: null,
          description: "",
          file_seq: atth.file_seq,
          messages: val.messages,
          files: atth,
        };
        data.documents.push(fileObject);
        setSubmissionValue({ ...submissionValue, ...data });
        dispatch({
          type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
          data: { ...submissionValue, data },
        });
      }
    }
    buildAlert({
      // Alert Type: success, info, warning, error
      type: "success",
      title: "Success Alert",
      content: "The Files have been added to Transmittal",
    });
  };

  const filePreviewDialogHandleOpen = () => {
    setFilePreviewDialogOpen(true);
  };
  const viewFileAction = (fileCat, fileSeq, filename) => {
    SetFilePreviewProperty({
      from: "API",
      autoLoading: true,
      file_cat: fileCat,
      file_ref: fileSeq,
      file_name: filename,
    });

    filePreviewDialogHandleOpen();
  };

  const confirmDialogHandleClose = () => {
    setConfirmDialogOpen(false);
  };

  const removeFileCancelAction = () => {
    confirmDialogHandleClose();
  };
  const removeFileConfirmAction = (fileRecord) => {
    confirmDialogHandleOpen({
      dialogTitle: "RFI attachment file remove",
      dialogContent: "Are you sure to remove the attachment file?",
      confirmAction: () => removeFileAction(fileRecord),
      cancelAction: removeFileCancelAction,
    });
  };
  const removeFileAction = (fileRecord) => {
    let result;
    let data = { ...softCopyTemplate };
    let transmittalData = { ...submissionValue };
    let removeAtthSeq = { ...removeRFIAtt };

    if (fileRecord.atth_seq !== undefined) {
      removeRFIAtt.removeRFIArr.push(fileRecord.atth_seq);
    }

    result = [...softCopyTemplate.messages.files].filter(
      (res) => res !== fileRecord
    );
    data.messages.files = result;

    setSoftCopyTemplate({ ...softCopyTemplate, ...data });
    setRemoveRFIAtt({ ...removeRFIAtt, ...removeAtthSeq });
    dispatch({
      type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
      data: { ...softCopyTemplate, ...data },
    });

    result = [...submissionValue.documents].filter(
      (res) => res.file_seq !== fileRecord.file_seq
    );

    transmittalData.documents = result;

    setSubmissionValue({ ...submissionValue, ...transmittalData });
    dispatch({
      type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
      data: { ...submissionValue, ...transmittalData },
    });

    confirmDialogHandleClose();
  };

  // Dialog Button Function
  const fileManagerFileSelected = async () => {
    if (propertySeqRedux === null) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Not any file choice, Please choice the file first.",
      });

      return;
    }

    if (propertySeqRedux.length === 0) {
      buildAlert({
        // Alert Type: success, info, warning, error
        type: "warning",
        title: "Warning Alert",
        content: "Not any file choice, Please choice the file first.",
      });

      return;
    }

    setPresetFiles(await getFile(propertySeqRedux));

    fileManagerDialogHandleClose();
  };
  // Dialog Button
  const fileManagerDialogBtn = [
    {
      buttonName: "OK",
      buttonFunction: fileManagerFileSelected,
      chooseFile: false,
    },
  ];

  // Clear Data
  const clearFileChoice = () => {
    dispatch({
      type: "FILE_SELECT",
      data: null,
    });
  };

  const annotationSaveActionHandleClose = () => {
    confirmDialogHandleClose();
  };

  //File Manager
  const fileManagerDialogHandleOpen = () => {
    setFileManagerDialogOpen(true);
  };

  const fileManagerDialogHandleClose = () => {
    clearFileChoice();
    setFileManagerDialogOpen(false);
  };

  let fileAttachmentPreviewDialogBtn = [];

  // Build Save Warn Dialog
  const saveWarnDialogHandleOpen = (data) => {
    setSaveWarnDialogData({
      dialogTitle: data.dialogTitle,
      dialogContent: data.dialogContent,
      saveAction: data.saveAction,
      dontSaveAction: data.dontSaveAction,
      cancelAction: data.cancelAction,
    });
    setSaveWarnDialogOpen(true);
  };

  const filePreviewDialogHandleClose = () => {
    if (!store.get("annotActive")) {
      setFilePreviewDialogOpen(false);
    } else {
      alertSaveActionHandleOpen();
    }
  };

  const saveWarnDialogHandleClose = () => {
    setSaveWarnDialogOpen(false);
  };

  const alertSaveActionHandleClose = () => {
    saveWarnDialogHandleClose();
  };

  const alertSaveAnnotation = () => {
    annotationSaveAction();

    alertSaveActionHandleClose();
    setFilePreviewDialogOpen(false);
  };

  const alertDontSaveAnnotation = () => {
    alertSaveActionHandleClose();
    setFilePreviewDialogOpen(false);
  };

  const annotationSaveActionHandleOpen = () => {
    confirmDialogHandleOpen({
      dialogTitle: "Annotation Save",
      dialogContent: "Are you sure to save the annotation.",
      confirmAction: annotationSaveAction,
      cancelAction: annotationSaveActionHandleClose,
    });
  };

  if (userModulesRedux !== null) {
    userModulesRedux.map((module) => {
      // if (module.path === "/circulation") {
      if (module.rights.modifiable || module.rights.administrable) {
        // fileAttachmentPreviewDialogBtn = [
        //   {
        //     // buttonName: "Annotation Save",
        //     // buttonFunction: annotationSaveActionHandleOpen,
        //     // chooseFile: false,
        //   },
        // ];
      }
    });
  }
  const alertSaveActionHandleOpen = () => {
    saveWarnDialogHandleOpen({
      dialogTitle: "Annotation Change Warning",
      dialogContent: "Do you want to save the change of annotation.",
      saveAction: alertSaveAnnotation,
      dontSaveAction: alertDontSaveAnnotation,
      cancelAction: alertSaveActionHandleClose,
    });
  };
  const annotationSaveAction = () => {
    webViewerSaveAnnotation(
      filePreviewProperty.fileCategory,
      filePreviewProperty.fileSequence
    ).then((res) => {
      annotationSaveActionHandleClose();

      if (res.type === "success") {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "success",
          title: "Success Alert",
          content: "The Annotation have been save",
        });
      } else {
        buildAlert({
          // Alert Type: success, info, warning, error
          type: "error",
          title: "Error Alert",
          content: res.message,
        });
      }
    });
  };

  useEffect(() => {
    let data = { ...softCopyTemplate };

    data.messages.dms_property_seqs = propertySeqRedux;

    if (presetFiles !== null) {
      data.messages.files.push(...presetFiles);
    }
    setSoftCopyTemplate({ ...softCopyTemplate, ...data });
    dispatch({
      type: "ADD_TRANSMITTAL_SOFTCOPY_SUBMISSION_VALUE",
      data: { ...softCopyTemplate, ...data },
    });
    const val = { ...softCopyTemplate };
    for (const atth of val.messages.files) {
      let data = { ...submissionValue };
      if (
        data.documents.map((obj) => obj.file_seq).indexOf(atth.file_seq) === -1
      ) {
        let fileObject = {
          id: uuidv4(),
          material: atth.filename,
          type: "softcopy",
          ref_no: "",
          atthDate: null,
          description: "",
          file_seq: atth.file_seq,
          messages: val.messages,
          files: atth,
        };
        data.documents.push(fileObject);
        setSubmissionValue({ ...submissionValue, ...data });
        dispatch({
          type: "ADD_TRANSMITTAL_SUBMISSION_VALUE",
          data: { ...submissionValue, data },
        });
      }
    }
  }, [presetFiles]);

  return (
    <Fragment>
      <Alert
        open={alertOpen}
        alertType={alertData.type}
        alertTitle={alertData.title}
        alertContent={alertData.content}
        handleClose={() => setAlertOpen(false)}
      />
      <FullScreenDialog
        open={fileManagerDialogOpen}
        dialogTitle={"File Choice From eFiling "}
        formContent={
          <Efiling fileManagerType={"select"} /> // main => Main File Manager, select => Select File From File Manager
        }
        button={fileManagerDialogBtn}
        handleClose={fileManagerDialogHandleClose}
      />
      <FullScreenDialog
        open={filePreviewDialogOpen}
        dialogTitle={"Transmittal Attachment File Preview"}
        formContent={
          <WebViewer
            property={filePreviewProperty}
            readOnly={true}
            zoom={false}
            move={false}
            ocr={false}
            // annotationChangeAlert={annotationChangeAlert}
            // setAnnotationChangeAlert={setAnnotationChangeAlert}
          />
        }
        button={fileAttachmentPreviewDialogBtn}
        handleClose={filePreviewDialogHandleClose}
      />
      <SaveWarnDialog
        open={saveWarnDialogOpen}
        dialogTitle={saveWarnDialogData.dialogTitle}
        dialogContent={saveWarnDialogData.dialogContent}
        saveAction={saveWarnDialogData.saveAction}
        dontSaveAction={saveWarnDialogData.dontSaveAction}
        cancelAction={saveWarnDialogData.cancelAction}
      />
      <ConfirmDialog
        open={confirmDialogOpen}
        dialogTitle={confirmDialogData.dialogTitle}
        dialogContent={confirmDialogData.dialogContent}
        confirmAction={confirmDialogData.confirmAction}
        cancelAction={confirmDialogData.cancelAction}
      />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <div className={classes.fileUploadBtnArea}>
            <Legend id="attachment" label="ATTACHMENT">
              <Box className={classes.addFileBtnArea}>
                <FileDropzone
                  key={"softcopy_attachment"}
                  title={""}
                  fileType={"softcopy_attachment"}
                  disabled={false}
                  fileUploadAction={fileUploadAction}
                  fileRemoveAction={removeFileConfirmAction}
                  viewFileAction={viewFileAction}
                  isNew={isNew}
                  DropzoneContent={TransmittalFileZoneContent}
                  openFileManagerDialog={fileManagerDialogHandleOpen}
                />
              </Box>
            </Legend>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default TransmittalSoftCopy;
